import PropTypes from "prop-types";
import { getPrice, isDiscounted } from "../../../utils/discountPriceData";
import { SECONDARY_PRICE } from "../priceTypes";
import CurrentPrice from "../currentPrice/CurrentPrice";
import PreviousPrice from "../previousPrice/PreviousPrice";
import styles from "./SecondaryPrice.scss";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";
import PercentageDiscount from "../percentageDiscount/PercentageDiscount";
import useRemoveDiscountPercentage from "../../../hooks/useRemoveDiscountPercentage";

export default function SecondaryPrice({ priceData }) {
  const { getTranslation } = useRuntimeConstants();
  const { shouldRemoveDiscountPercentage } = useRemoveDiscountPercentage();
  const isPriceDiscounted = isDiscounted(priceData);
  const { currentPriceText, previousPriceText, percentageDiscountLabel } =
    getPrice({ translations: getTranslation, priceData });

  return (
    <div className={styles.secondaryPrice}>
      {isPriceDiscounted && !shouldRemoveDiscountPercentage && (
        <PreviousPrice
          previousPriceText={previousPriceText}
          priceStyle={SECONDARY_PRICE}
        />
      )}
      <span className={styles.priceAndDiscount}>
        <CurrentPrice
          currentPriceText={currentPriceText}
          showVatMessage={false}
          priceStyle={SECONDARY_PRICE}
          isSalePrice={isPriceDiscounted}
        />
        {isPriceDiscounted && !shouldRemoveDiscountPercentage && (
          <PercentageDiscount
            percentageDiscountLabel={percentageDiscountLabel}
          />
        )}
      </span>
    </div>
  );
}

SecondaryPrice.propTypes = {
  priceData: PropTypes.shape({
    current: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number,
    }).isRequired,
    previous: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number,
    }),
    rrp: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number,
    }),
    isMarkedDown: PropTypes.bool,
    isOutletPrice: PropTypes.bool,
  }).isRequired,
};
